<template>
	<div>
		<div class="row checkbox-radios">
			<div class="col-12">
				<base-radio v-for="(el_opt, el_index) in masRadio" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="value[range_keys[0]]" inline>{{el_opt.label}}</base-radio>
			</div>
			<div class="col-12 mt-2" v-if="value[range_keys[0]] == '-1'">
				<ReDateRange 
					:range_separator="'-'"
					:start_placeholder="'От'"
					:end_placeholder="'До'"
					v-model="value[range_keys[1]]"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	import ReDateRange from 'src/our_components/ReDateRange.vue';
	export default {
		name: 'ReStrangeDateRange',
		components: {
			BaseRadio,
			ReDateRange
		},
		props: {
			value: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			noDetail:{ // скрывать выбор дат
				type: Boolean,
				defaule: false
			}
		},
		data () {
			return {
				/**
				 * Отдаёт дату из прошлого по её индексу или описанию из параметра
				 * @param string индекс или название даты из прошлого:
					0 or today - начало сегодняшнего дня
					1 or last_week - за последние 7 дней
					2 or last_month - за последний месяц
					3 or last_quarter - за последний квартал
					4 or last_halfyear - за пол года
					5 or last_year - за последний год
					@return string - дата строкой
				*/
				ver: 1,
				masRadio:[
					{name: '-2', label: 'Все',},
					{name: '0', label: 'День',},
					/*{name: '1', label: 'Неделя',},*/
					{name: '2', label: 'Месяц',},
					/*{name: '3', label: 'Квартал',},*/
					{name: '5', label: 'Год',}
				].concat(this.noDetail?[]:[{name: '-1', label: 'Период',}]),
			}
		},
		computed: {
			range_type(){return this.value[this.range_keys[0]];},
			range_keys(){return Object.keys(this.value);}
		},
		watch:{
			range_type(val){
				if(this.value[this.range_keys[0]] != '-1'){
					this.value[this.range_keys[1]] = {startDt: '',endDt:''};
				}
			}
		},
		methods: {

		},
	}
</script>
<style scoped>

</style>
